import { Injectable } from '@angular/core';

import { JoyrideOptions, StepPosition } from '../joyride.domain';

export interface IJoyrideOptionsService {
  setOptions(options: JoyrideOptions): void;
  getStepDefaultPosition();
  getStepsOrder(): Array<string>;
  getFirstStep(): string;
  getWaitingTime(): number;
  isCounterVisible(): boolean;
  isPrevButtonVisible(): boolean;
}

@Injectable({ providedIn: 'root' })
export class JoyrideOptionsService implements IJoyrideOptionsService {
  private static readonly STEP_DEFAULT_POSITION: StepPosition = StepPosition.BOTTOM;
  private static readonly DEFAULT_TIMEOUT_BETWEEN_STEPS: number = 1;

  private stepDefaultPosition: StepPosition = JoyrideOptionsService.STEP_DEFAULT_POSITION;
  private showCounter: boolean = true;
  private showPrevButton: boolean = true;
  private showCloseButton: boolean = true;
  private standalonePrevButton: boolean = false;
  private stepsOrder: Array<string> = [];
  private firstStep: string;
  private waitingTime: number;

  setOptions(options: JoyrideOptions): void {
    this.stepsOrder = options.steps;
    this.stepDefaultPosition = options.stepDefaultPosition
      ? options.stepDefaultPosition
      : this.stepDefaultPosition;
    this.showCounter = typeof options.showCounter !== 'undefined'
      ? options.showCounter
      : this.showCounter;
    this.showPrevButton = typeof options.showPrevButton !== 'undefined'
      ? options.showPrevButton
      : this.showPrevButton;
    this.showCloseButton = typeof options.showCloseButton !== 'undefined'
      ? options.showCloseButton
      : this.showCloseButton;
    this.standalonePrevButton = typeof options.standalonePrevButton !== 'undefined'
      ? options.standalonePrevButton
      : this.standalonePrevButton;
    this.firstStep = options.startWith;
    this.waitingTime = typeof options.waitingTime !== 'undefined'
      ? options.waitingTime
      : JoyrideOptionsService.DEFAULT_TIMEOUT_BETWEEN_STEPS;
  }

  getStepDefaultPosition(): string {
    return this.stepDefaultPosition;
  }

  getStepsOrder(): Array<string> {
    return this.stepsOrder;
  }

  getFirstStep(): string {
    return this.firstStep;
  }

  getWaitingTime(): number {
    return this.waitingTime;
  }

  isCounterVisible(): boolean {
    return this.showCounter;
  }

  isPrevButtonVisible(): boolean {
    return this.showPrevButton;
  }

  isCloseButtonVisible(): boolean {
    return this.showCloseButton;
  }

  isPrevButtonStandalone(): boolean {
    return this.standalonePrevButton;
  }
}
